import React from 'react';
import Layout from '@common/layout';
import AccountLinking from '@components/accountLinking';
import { getAccessToken } from '@repository/AccessToken';
import LoginModal from '@components/loginModal';

const MatchLoginPage = () => {
  //미 로그인 상태일 경우
  if (!getAccessToken())
    return (
      <Layout>
        <LoginModal subTitle="채용정보 · 역량검사 · 매칭까지" title="취업기회 지금 바로 잡다!" visible={true} />
      </Layout>
    );

  return (
    <Layout>
      <AccountLinking />
    </Layout>
  );
};

export default MatchLoginPage;
